import React from "react";
import SingleSelectNew from "./SingleSelectNew";
const DefaultsDropdownContainer = ({ onChange, selectedValue, className, frequency, disabled = false, labelInValue = null, error = null, defaultOptions = [], }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(SingleSelectNew, { options: defaultOptions, selectedValue: selectedValue, onChange: onChange, placeholder: "Please Select", key: "defaultSelect", textProperty: "text", valueProperty: "value", className: className, disabled: disabled, labelInValue: labelInValue, allowClear: false, error: error })));
};
export default React.memo(DefaultsDropdownContainer);
